import { WritableDraft, produce } from '@/globals/helpers/immer';
import {
	ResultCategorisationRendered,
	ResultCategoryRendered,
	ResultRendered,
} from '@/app/decisionToolArticle/_data/decisionToolRendered.types';
import { getRelevantQuestions } from './filterQuestions';
import {
	AnyRenderedQuestion,
	GivenAnswers,
} from '../_questions/question.types';
import { matchConditions } from './matchConditions';

export const getRelevantResults = (
	results: Array<ResultRendered>,
	questions: Array<AnyRenderedQuestion>,
	givenAnswers: GivenAnswers,
) => {
	const relevantQuestions = getRelevantQuestions(questions, givenAnswers);

	const relevantResults = results.filter((result) => {
		const isMatch = matchConditions({
			givenAnswers,
			relevantQuestions,
			allQuestions: questions,
			item: result,
		});

		return isMatch;
	});

	return relevantResults;
};

export const getCategoryWithFilteredResults = produce(
	(
		resultCategoryDraft: WritableDraft<ResultCategoryRendered>,
		relevantResultIds: Array<string>,
	) => {
		resultCategoryDraft.resultIds = resultCategoryDraft.resultIds.filter(
			(resultId) => {
				return relevantResultIds.includes(resultId);
			},
		);
	},
);

export const getCategorisationWithFilteredCategories = produce(
	(
		resultCategorisationDraft: WritableDraft<ResultCategorisationRendered>,
		relevantResultIds: Array<string>,
	) => {
		resultCategorisationDraft.categories = resultCategorisationDraft.categories
			.map((resultCategory) => {
				return getCategoryWithFilteredResults(
					resultCategory,
					relevantResultIds,
				);
			})
			.filter((resultCategory) => {
				return resultCategory.resultIds.length > 0;
			});
	},
);

export const getFilteredResultCategorisations = produce(
	(
		resultCategorisations: Array<ResultCategorisationRendered>,
		relevantResultIds: Array<string>,
	) => {
		return resultCategorisations
			.map((resultCategorisation) => {
				return getCategorisationWithFilteredCategories(
					resultCategorisation,
					relevantResultIds,
				);
			})
			.filter((resultCategorisation) => {
				return resultCategorisation.categories.length > 0;
			});
	},
);
